import { useMutation } from '@tanstack/react-query';
import { CreateFirebaseNotification, DeleteFirebaseNotifications, UpdateFirebaseNotification } from '../../../Api/firebasenotifications';

export const useMutateCreateFirebaseNotification = () =>
  useMutation({
    mutationFn: (data) => CreateFirebaseNotification(data),
  });

export const useMutateEditFirebaseNotification = () =>
  useMutation({
    mutationFn: ({ id, data }) => UpdateFirebaseNotification(id,data),
  });


export const useMutateDeleteNotifications = () =>
  useMutation({
    mutationFn: (data) => DeleteFirebaseNotifications(data),
  });
